export const layerOptionsCLT = [
  { label: 'Produktschicht', value: 'product-layer' },
  { label: 'CLT Schicht', value: 'clt-assembly-layer' },
  { label: 'Plattenschicht', value: 'plate-layer' },
]

export const layerOptionsTimberFrameWall = [
  { label: 'Produktschicht', value: 'product-layer' },
  { label: 'Plattenschicht', value: 'plate-layer' },
  { label: 'Holzrahmenschicht', value: 'timber-frame-layer-wall' },
]

export const layerOptionsTimberFrameRoofCeiling = [
  { label: 'Produktschicht', value: 'product-layer' },
  { label: 'Plattenschicht', value: 'plate-layer' },
  { label: 'Holzbalkenschicht', value: 'timber-frame-layer-roof-ceiling' },
]
